$(function() {

  if($('.mypage-List').length) {
    $('.mypage-List_Name, .mypage-List_Value').matchHeight();
  }

}());
